import { Injectable } from '@angular/core';
import { Experience, MarkersExperience } from '../models/ToursModels';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { BehaviorSubject, Observable, Subscription, of, take, } from 'rxjs';
import { ViewsExperiences } from '../models/views-experiences';
import { citiesAndRegions } from '../enums & constants/main-citys-regions';
import { CityRegion } from '../models/city-region';
import { ExperienceFilter } from '../models/experience-list';
import { TravelGuide } from '../models/travel-guide.models';

const TABLE = "travelGuides";

@Injectable({
  providedIn: 'root'
})
export class TravelGuidesService {

  citiesAndRegions: CityRegion[] = citiesAndRegions;

  private unfilteredTravelGuides: TravelGuide[] = [];
  private allTravelGuides: TravelGuide[] = [];
  private travelGuidesProvider = new BehaviorSubject<TravelGuide[]>([]);
  public $allTravelGuides = this.travelGuidesProvider.asObservable();
  public getAllTravelGuidesSubscription: Subscription;

  private cityRegionSelectedSubject = new BehaviorSubject<CityRegion | null>(null);
  cityRegionSelectedSubject$ = this.cityRegionSelectedSubject.asObservable();

  private travelGuideByCityRegionSubject = new BehaviorSubject<TravelGuide[]>([]);
  travelGuideByCityRegion$ = this.travelGuideByCityRegionSubject.asObservable();

  private travelGuidesLoaded = new BehaviorSubject<boolean>(false);
  public $travelGuidesLoaded = this.travelGuidesLoaded.asObservable();

  private markerExperienceSelected = new BehaviorSubject<MarkersExperience | null>(null);
  public $markerExperienceSelected = this.markerExperienceSelected.asObservable();

  private readonly localStorageKey = 'viewsExperiences';

  public isFirstLoad = true;

  constructor(public fireStore: AngularFirestore) {
    this.getTravelGuides();
    this.$travelGuidesLoaded.subscribe((isDone) => {
      if (isDone) {
        const defaultCityRegion = this.citiesAndRegions[0];
        this.setCityRegion(defaultCityRegion);
      }
    });
  }

  getTravelGuides() {
    this.getAllTravelGuidesSubscription = this.fireStore.collection<TravelGuide>(TABLE, ref => ref)
      .valueChanges({ idField: '_id' }).subscribe((data) => {
        if (data.length) {
          this.unfilteredTravelGuides = data;

          let onlyActiveExperiences = data.filter((item) => {
            return item?.isActive;
          });
          this.allTravelGuides = onlyActiveExperiences.map((experienceData) => new TravelGuide(experienceData));
          this.travelGuidesProvider.next(this.allTravelGuides);
          this.getAllTravelGuidesSubscription.unsubscribe();
          this.travelGuidesLoaded.next(true);
        }
      });
  }


  setCityRegion(cityRegion: CityRegion): void {
    this.cityRegionSelectedSubject.next(cityRegion);
    this.setTravelGuideByCityRegion(cityRegion);

  }

  setTravelGuideByCityRegion(cityRegion: CityRegion): void {
    const travleGuidesByCityRegion = this.travelGuidesProvider.value.filter(exp => exp.mainCityRegionId === cityRegion.id);
    this.travelGuideByCityRegionSubject.next(travleGuidesByCityRegion);
  }


  updatedTravelGuideLikesCount(travelGuideId, newCount: number): Promise<void> {
    let affectedTravelGuide = this.travelGuidesProvider.value.find((travelGuide) => {
      return travelGuide._id == travelGuideId;
    })

    let travelGuideRef: AngularFirestoreDocument<TravelGuide>;

    if (affectedTravelGuide) {
      affectedTravelGuide.countLikes = newCount;

      travelGuideRef = this.fireStore.doc(
        `${TABLE}/${affectedTravelGuide._id}`
      );

      return travelGuideRef.update({ "countLikes": newCount });
    }

  }



}
